import ConfirmDialogContent from "@/lib/components/interactions/dialogs/ConfirmDialogContent";
import { type LocaleDictionaryType } from "@/lib/main";
import useDialog from "./useDialog";

type PropsType = {
  title?: LocaleDictionaryType;
  message: LocaleDictionaryType;
  confirmText: LocaleDictionaryType;
  cancelText: LocaleDictionaryType;
  handleConfirm: () => void;
  handleCancel?: () => void;
  breakpoint?: number;
};

export default function useConfirmDialog({
  title,
  message,
  confirmText,
  cancelText,
  handleConfirm,
  handleCancel,
  breakpoint,
}: PropsType) {
  const { dialogRef, showDialog, setShowDialog, setContent, closeDialog } =
    useDialog();

  const handleConfirmClick = () => {
    handleConfirm();
    closeDialog();
  };

  const handleCancelClick = () => {
    handleCancel?.();
    closeDialog();
  };

  const handleOpenConfirmDialogClick = () => {
    if (showDialog) return;

    setContent(
      <ConfirmDialogContent
        title={title}
        message={message}
        confirmText={confirmText}
        cancelText={cancelText}
        handleConfirmClick={handleConfirmClick}
        handleCancelClick={handleCancelClick}
        breakpoint={breakpoint}
      />,
    );

    setShowDialog(true);
    dialogRef.current?.focus();
  };

  return { handleOpenConfirmDialogClick };
}
